import {
  ActionType,
  IStressCheckListResponse,
  StressCheckListData,
} from "models/stressCheck/stressCheckList";

export const stressCheckListAction = (payload: StressCheckListData) => {
  return {
    type: ActionType.STRESS_CHECK_LIST,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.STRESS_CHECK_LIST_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IStressCheckListResponse) => {
  return {
    type: ActionType.STRESS_CHECK_LIST_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.STRESS_CHECK_LIST_RESET_DATA,
  };
};
